<!--Options-->
<div class="OptionBorder">
	<!--Instructions-->
	<div>
		<ul>
			<li>
				<label> Select which group-assigned items you want to keep or delete. </label>
			</li>

			<li>
				<label>
					Ex. Keeping Incidents means the student will still have the incident and suspension (if any) but it will not be associated with this group.
				</label>
			</li>

			<li>
				<label> Ex. Checking the box to delete PBIS points means the points will be voided and the student's balance will be recalculated. </label>
			</li>
		</ul>
	</div>

	<div class="OptionGrid">
		<label for="DeletePBIS">Delete PBIS Points</label>
		<input class="CHK" id="DeletePBIS" type="checkbox" [(ngModel)]="DeletePBIS" />

		<label for="DeleteReleases">Delete Releases</label>
		<input class="CHK" id="DeleteReleases" type="checkbox" [(ngModel)]="DeleteReleases" />

		<label for="DeleteIncidents">Delete Incidents</label>
		<input class="CHK" id="DeleteIncidents" type="checkbox" [(ngModel)]="DeleteIncidents" />
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onDelete()">Delete Group</button>
	<button class="btn btn-warning" (click)="onClose()">Cancel</button>
</div>
